import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = "حآلة حاسبة للكسور - حل مسائل الكسور مع بسط ومقام";
const DESCRIPTION = "أداة متكاملة لحساب الكسور الرياضية! تقوم حاسبتنا بإجراء جميع عمليات الكسور من جمع وطرح وضرب وقسمة، مع إظهار الحل المفصل للبسط والمقام. حل مسائل الكسور بسهولة ودقة عالية";
const KEYWORDS ="حاسبة كسور، حاسبة الكسور، حاسبه كسور، حل الكسور، حاسبة بسط ومقام، كسور رياضية، جمع كسور، طرح كسور، ضرب كسور، قسمة كسور، آلة حاسبة كسور، حل مسائل الكسور، كسور رياضيات، حاسبة كسرية، أداة حل الكسور";
const OG_URL = "https://do-calculate.com/calculator/ar/fractions-calculator/";
function FractionsCalculator() {
  const [numerator1, setNumerator1] = useState(0);
  const [denominator1, setDenominator1] = useState(1);
  const [numerator2, setNumerator2] = useState(0);
  const [denominator2, setDenominator2] = useState(1);
  const [operation, setOperation] = useState("+");
  const [resultNum, setResultNum] = useState(null);
  const [resultDenom, setResultDenom] = useState(null);
  const [steps, setSteps] = useState([]);
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      let num1 = parseInt(numerator1);
      let denom1 = parseInt(denominator1);
      let num2 = parseInt(numerator2);
      let denom2 = parseInt(denominator2);
      let resultNum, resultDenom;
      let calculationSteps = [];
      switch (operation) {
        case "+":
          resultNum = num1 * denom2 + num2 * denom1;
          resultDenom = denom1 * denom2;
          calculationSteps.push(
            `الخطوة 1: ضرب البسط والمقام للكسر الأول والثاني بحيث يتم توحيد المقامات: (${num1} * ${denom2}) + (${num2} * ${denom1})`
          );
          calculationSteps.push(
            `الخطوة 2: جمع البسطين: ${num1 * denom2} + ${
              num2 * denom1
            } = ${resultNum}`
          );
          calculationSteps.push(
            `الخطوة 3: المقام النهائي هو حاصل ضرب المقامين: ${denom1} * ${denom2} = ${resultDenom}`
          );
          break;
        case "-":
          resultNum = num1 * denom2 - num2 * denom1;
          resultDenom = denom1 * denom2;
          calculationSteps.push(
            `الخطوة 1: ضرب البسط والمقام للكسر الأول والثاني بحيث يتم توحيد المقامات: (${num1} * ${denom2}) - (${num2} * ${denom1})`
          );
          calculationSteps.push(
            `الخطوة 2: طرح البسطين: ${num1 * denom2} - ${
              num2 * denom1
            } = ${resultNum}`
          );
          calculationSteps.push(
            `الخطوة 3: المقام النهائي هو حاصل ضرب المقامين: ${denom1} * ${denom2} = ${resultDenom}`
          );
          break;
        case "*":
          resultNum = num1 * num2;
          resultDenom = denom1 * denom2;
          calculationSteps.push(
            `الخطوة 1: ضرب البسطين: ${num1} * ${num2} = ${resultNum}`
          );
          calculationSteps.push(
            `الخطوة 2: ضرب المقامين: ${denom1} * ${denom2} = ${resultDenom}`
          );
          break;
        case "/":
          resultNum = num1 * denom2;
          resultDenom = denom1 * num2;
          calculationSteps.push(
            `الخطوة 1: ضرب البسط للكسر الأول في مقام الكسر الثاني: ${num1} * ${denom2} = ${resultNum}`
          );
          calculationSteps.push(
            `الخطوة 2: ضرب المقام للكسر الأول في بسط الكسر الثاني: ${denom1} * ${num2} = ${resultDenom}`
          );
          break;
        default:
          setError("يرجى اختيار عملية حسابية صحيحة.");
          return;
      }
      setResultNum(resultNum);
      setResultDenom(resultDenom);
      setSteps(calculationSteps);
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  حاسبة الكسور الشاملة: أداة مجانية وسهلة الاستخدام لحساب الكسور
                  بكل بساطة وفعالية. تدعم الحاسبة جميع العمليات الحسابية
                  الأساسية للكسور: الجمع، الطرح، الضرب، والقسمة. مثالية لحل
                  مسائل الكسور في الرياضيات والعلوم، تساعدك الحاسبة على توفير
                  الوقت والجهد والحصول على نتائج دقيقة في ثوانٍ معدودة. استخدمها
                  بسهولة وسرعة، مثالية للطلاب والمعلمين والمهندسين وغيرهم ممن
                  يتعاملون مع الكسور بشكل يومي.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>آلة حاسبة للكسور - تبسيط، إضافة، طرح، ضرب وقسمة الكسور</h2>
                </div>
                <div dir="rtl">
                  <div>
                    <hr />
                    <div className="d-flex justify-content-center align-items-center">
                      <div>
                        <input
                          type="number"
                          value={numerator1}
                          onChange={(e) => setNumerator1(e.target.value)}
                          placeholder="البسط 1"
                          className="form-control"
                          style={{ width: "50px", textAlign: "center" }}
                        />
                        <hr />
                        <input
                          type="number"
                          value={denominator1}
                          onChange={(e) => setDenominator1(e.target.value)}
                          placeholder="المقام 1"
                          className="form-control"
                          style={{ width: "50px", textAlign: "center" }}
                        />
                      </div>
                      <div className="mx-2" htmlFor="operation">
                        <select
                          id="operation"
                          value={operation}
                          onChange={(e) => setOperation(e.target.value)}
                          className="form-select"
                          style={{ width: "70px", textAlign: "center" }}
                        >
                          <option value="+">+</option>
                          <option value="-">-</option>
                          <option value="*">*</option>
                          <option value="/">/</option>
                        </select>
                      </div>
                      <div>
                        <input
                          type="number"
                          value={numerator2}
                          onChange={(e) => setNumerator2(e.target.value)}
                          placeholder="البسط 2"
                          className="form-control"
                          style={{ width: "50px", textAlign: "center" }}
                        />
                        <hr />
                        <input
                          type="number"
                          value={denominator2}
                          onChange={(e) => setDenominator2(e.target.value)}
                          placeholder="المقام 2"
                          className="form-control"
                          style={{ width: "50px", textAlign: "center" }}
                        />
                      </div>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      احسب                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      خطأ: {error}
                    </p>
                  )}
                  {resultNum !== null && resultDenom !== null &&  (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>النتيجة:</h4>
                      <div className="fraction-result">
                        <p>
                          <sup>{resultNum}</sup>/<sub>{resultDenom}</sub>
                        </p>
                      </div>
                      <div>
                        <h5>الخطوات:</h5>
                        {steps.map((step, index) => (
                          <p key={index}>{step}</p>
                        ))}
                      </div>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">معلومات إضافية</div>
              <div className="info-section-body">
                <b>
                  <u>ما هي حاسبة الكسور؟</u>
                </b>
                <p>
                  حاسبة الكسور هي أداة تساعدك على إجراء العمليات الحسابية
                  الأساسية مثل الجمع، الطرح، الضرب، والقسمة على الكسور. يتم
                  تبسيط النتيجة تلقائيًا إلى أبسط صورة.
                </p>
                <b>
                  <u>كيفية استخدام الحاسبة</u>
                </b>
                <p>
                  لاستخدام الحاسبة، قم بإدخال البسط والمقام لكل كسر، ثم اختر
                  العملية الحسابية التي ترغب في القيام بها. أخيرًا، انقر على زر
                  "احسب" للحصول على النتيجة.
                </p>
                <b>
                  <u>شرح النتائج</u>
                </b>
                <p>
                  ستعرض الحاسبة النتيجة ككسر مبسط بالإضافة إلى الخطوات التفصيلية
                  المستخدمة للوصول إلى هذه النتيجة.
                </p>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default FractionsCalculator;
